import { motion } from 'motion/react';

export const At = ({
  top,
  left,
  children,
}: {
  top: string;
  left: string;
  children: React.ReactNode;
}) => (
  <div className="absolute" style={{ top, left }}>
    {children}
  </div>
);

export const Drift = ({
  duration = 7,
  delay = 0,
  children,
}: {
  duration?: number;
  delay?: number;
  children: React.ReactNode;
}) => (
  <motion.div
    animate={{ y: [-7, 5, -7], rotate: [0.8, -0.6, 0.8] }}
    transition={{ duration, delay, repeat: Infinity, ease: 'easeInOut' }}
  >
    {children}
  </motion.div>
);

export const Float = ({
  y = [-12, 0],
  duration = 5,
  delay = 0,
  children,
}: {
  y?: number[];
  duration?: number;
  delay?: number;
  children: React.ReactNode;
}) => (
  <motion.div
    animate={{ y }}
    transition={{
      duration,
      delay,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut',
    }}
  >
    {children}
  </motion.div>
);

export const Pulse = ({
  duration = 3,
  delay = 0,
  children,
}: {
  duration?: number;
  delay?: number;
  children: React.ReactNode;
}) => (
  <motion.div
    animate={{ scale: [1, 0.6, 1], opacity: [0.75, 0.3, 0.75] }}
    transition={{ duration, delay, repeat: Infinity, ease: 'easeInOut' }}
  >
    {children}
  </motion.div>
);
